// Affected Levels
export const AFFECTED_LEVELS = {
  OFFER: 'Offer',
  AFFILIATE: 'Affiliate',
  APPLICATION: 'Application',
  CAMPAIGN: 'Campaign',
  PARTNER_CAMPAIGN: 'PartnerCampaign',
  AD_SET: 'AdSet',
  AGGREGATED_PUBLISHER: 'AggregatedPublisher',
  AGGREGATED_PLACEMENT: 'AggregatedPlacement',
  PUBLISHER: 'Publisher',
  PLACEMENT: 'Placement',
  PARTNER_AD: 'PartnerAd',
  PLATFORM: 'Platform',
  REAL_COUNTRY: 'RealCountry',
  CONCEPT: 'CreativeConcept',
  CREATIVE_FILE: 'CreativeFile',
  TAG: 'Tag',
  INFLUENCER_CAMPAIGN: 'InfluencerCampaign',
  TRAFFIC_TYPE: 'TrafficType',
};

export const ADVERTISING_TARGET = 'target';
export const DYNAMIC_TARGET = 'dynamicTarget';
export const CREATIVES_TARGET = 'creativesTarget';
export const LAST_30_DAYS = 'Last30Days';

export const OWNER = 'owner';
